module.exports = __webpack_public_path__ + "img/icon_mine_coupon.3429dae5.png";